import { useCallback, useEffect, useRef } from "react";

export const useDebounceEffect = <T extends CallableFunction>(
  callback: T,
  msDelay: number
) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      callback();
    }, msDelay);
    return () => {
      timer && clearTimeout(timer);
    };
  }, [callback, msDelay]);
};

export const useDebounce = <T extends CallableFunction>(
  callback: T,
  msDelay: number
) => {
  const timer = useRef<NodeJS.Timer | null>(null);
  return useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    timer.current = setTimeout(() => {
      callback();
    }, msDelay);
  }, [callback, msDelay]);
};
